/**
 * Write your JS code here for frontend.
 */
import './modal';
import './lightbox';
import './controls';

window.IsPrefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
